<template>
  <el-dialog
    class="modal-menu-management"
    :title="title"
    :visible.sync="visible"
    @close="$_cancle"
    lock-scroll
    append-to-body
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    custom-class="greater"
  >
    <main class="content">
      <!-- 面包屑 -->
      <div class="breadcrumb">
        <a href="javascript:void(0);" @click="$_callbackFirst">一级菜单列表</a>
        <template v-for="(item, index) in fristNamelist">
          <span :key="item.code" class="split">/</span>
          <a
            :key="item.code"
            href="javascript:void(0);"
            v-if="index !== fristNamelist.length - 1"
            @click="$_callbackSec(index, item)"
          >{{item.fristName}}</a>
          <span v-else :key="item.code" class="active">{{item.fristName}}</span>
        </template>
      </div>
      <!-- 新增按钮 -->
      <div class="top-btns">
        <el-button @click="$_modify(-1)" class="btn__add">新增菜单</el-button>
      </div>

      <div class="table-box">
        <!-- 数据列表 -->
        <el-scrollbar style="483px;">
          <el-table
            class="table-list__box"
            ref="tableList"
            :data="dataList"
            :rowClassName="$_getRowClass"
            :height="481"
            v-loading="isLoading"
            stripe
            tooltip-effect="dark"
          >
            <el-table-column label="操作" width="308" :resizable="false">
              <template slot-scope="scope">
                <el-button v-if="!scope.row.isHasChild" @click="$_showButtonManager(scope.row)">按钮管理</el-button>
                <el-button class="edit__btn" @click="$_modify(scope.$index, scope.row)">编辑</el-button>
                <el-button class="delete__btn" @click="$_updateStatus(scope.row, 3)">删除</el-button>
              </template>
            </el-table-column>

            <el-table-column
              v-for="column in columns"
              :key="column.key"
              :prop="column.key"
              :label="column.label"
              :width="column.width"
              sortable
              show-overflow-tooltip
              filter-placement="bottom"
              v-if="!column.component"
            >
              <template slot-scope="scope">
                <template v-if="column.key == 'name'">
                  <div
                    @click="$_filterFun(scope.row)"
                    class="onmouses"
                    :class="[scope.row.isHasChild ? 'onmouses' : 'normalTxt']"
                  >{{ scope.row[column.key] }}</div>
                </template>
                <template v-else>{{ scope.row[column.key] }}</template>
              </template>
            </el-table-column>

            <el-table-column :prop="column.key" :label="column.label" :width="column.width" v-else>
              <template slot-scope="scope">
                <component :is="column.component" :row="scope.row" :tag="column.key"></component>
              </template>
            </el-table-column>

            <div v-show="!isLoading" class="table-list__empty" slot="empty"></div>
          </el-table>
        </el-scrollbar>

        <!-- 分页 -->
        <div class="pagination__wrapper">
          <cd-pagination
            ref="pager"
            :total="pagination.total"
            :currPage="pagination.pageNow"
            :pageSize="pagination.pageSize"
            @changepage="$_changeCurrent"
            @changesize="$_changeSize"
            :explainShow="true"
            @refresh="$_getOrderCompanys"
          ></cd-pagination>
        </div>
      </div>
    </main>

    <add-edit
      v-if="modal.show && modal.template === 'add-edit'"
      :title="modal.title"
      :formType="modal.type"
      :modalData="modal.data"
      @callback="$_callback"
      @close="$_close"
    ></add-edit>
    <!-- S 按钮管理 -->
    <button-manager
      v-if="modal.show && modal.template==='button-manager'"
      :title="modal.title"
      :paths="modal.data.paths"
      :menuItem="modal.data.menu"
      @path-to="$_callbackPath"
      @close="$_close"
    ></button-manager>
    <!-- E 按钮管理 -->
  </el-dialog>
</template>
<script>
import * as Utils from "@/plugins/utils";
import AddEdit from "./add-edit";
import ButtonManager from "./button-manager";

const columns = [
  { key: "icon", label: "菜单图标样式", width: 200 },
  { key: "name", label: "菜单名称", width: 120 },
  { key: "status", label: "是否显示", width: 120, component: "statues" },
  { key: "sort", label: "菜单顺序" }
];
export default {
  name: "menu-management",
  props: {
    title: { type: String, default: "" },
    formType: { type: String, default: "add" },
    modalData: {
      type: Object,
      default: function() {
        return {};
      }
    }
  },

  data() {
    return {
      visible: false,
      isLoading: false,
      dataList: [],
      columns,
      cid: "",
      level: 1,
      fristName: "",
      fristNamelist: [],
      page: "",
      code1: "",
      pagination: {
        pageNow: 1,
        pageSize: 20,
        pages: 0,
        total: 0
      },
      modal: {
        show: false,
        title: "",
        template: "",
        data: {}
      },
      rules: {},
      parentName: ""
    };
  },
  methods: {
    //点击面包屑
    $_callbackFirst() {
      if (this.code1 === "ROOT") return false;
      this.level = 1;
      this.code1 = "ROOT";
      this.fristNamelist.splice(0);
      this.pagination.pageNow = 1;
      this.$_getOrderCompanys();
    },
    $_callbackSec(index, item) {
      this.level = index + 2;
      if (this.code1 === item.code1) return false;
      this.code1 = item.code1;
      this.pagination.pageNow = 1;
      this.$_getOrderCompanys();
      this.fristNamelist.splice(
        index + 1,
        this.fristNamelist.length - (index + 1)
      );
    },
    //点击页面
    $_filterFun(row) {
      if (this.level >= 3) {
        console.log("三级了");
        return false;
      }
      this.level++;
      if (this.level === 1) {
        this.code1 = "ROOT";
      } else {
        this.code1 = row.code;
        this.fristName = row.name;
        this.fristNamelist.push({
          fristName: this.fristName,
          code1: this.code1
        });
        this.parentName = row.code;
      }
      this.pagination.pageNow = 1;
      this.$_getOrderCompanys();
    },
    // 切换每页size
    $_changeSize(page, size) {
      this.pagination.pageSize = size;
      this.pagination.pageNow = 1;
      this.$_getOrderCompanys();
    },
    // 切换当前页
    $_changeCurrent(val) {
      this.pagination.pageNow = val;
      this.$_getOrderCompanys();
    },
    // 查询接口列表
    $_getOrderCompanys() {
      this.isLoading = true;
      let code = "ROOT";
      if (this.level > 1) {
        code = this.code1;
      }
      const postData = {
        systemId: this.modalData.cid,
        parentCode: code,
        pageNow: this.pagination.pageNow,
        pageSize: this.pagination.pageSize
      };
      this.$service.post("pagingBySysAndParent", postData).then(result => {
        if (result.$.checkResult(result, true)) {
          this.pagination.pages = result.data.pages;
          this.pagination.total = result.data.total;
          this.dataList = result.data.rows.concat([]);
        }
        this.isLoading = false;
      });
    },
    $_getRowClass({ row, rowIndex }) {
      if (row.status === 2) {
        return "is-blocked";
      }
    },
    // 新增/编辑
    $_modify($index, row) {
      this.modal.type = "add";
      var cid = this.modalData.cid;
      this.modal.data = {
        level: this.level,
        parentName: this.parentName,
        cid,
        systemName: this.modalData.systemName
      };
      this.modal.title = "新增菜单";
      if ($index !== -1) {
        this.modal.type = "edit";
        row.level = this.level;
        row.cid = this.modalData.cid;
        row.systemName = this.modalData.systemName;
        this.modal.data = JSON.parse(JSON.stringify(row));
        this.modal.title = "编辑菜单";
      }
      this.modal.template = "add-edit";
      this.modal.show = true;
    },
    // 更新品牌状态 - 1-启用/2-停用/3-删除
    $_updateStatus(row, status) {
      const self = this;
      let content = `
            <div>是否删除当前选项？</div>
            <div style="color:#ea2a2a">*删除会影已配置得下级菜单,请谨慎操作！</div>
          `;
      let fid = [row.fid];
      $MessageBox.confirm({
        content,
        onOk() {
          self.$service
            .post("functionDelete", {
              fid
            })
            .then(result => {
              if (result.$.checkResult(result, true)) {
                $MessageBox.alert({
                  content: result.msg,
                  onOk() {
                    self.$_getOrderCompanys();
                  }
                });
              }
            });
        }
      });
    },
    $_cancle() {
      this.visible = false;
      this.$emit("close");
    },
    // 按钮管理弹窗中的path操作回调
    $_callbackPath(index, menu) {
      if (index === 0) {
        this.$_callbackFirst();
      } else {
        index--;
        this.$_callbackSec(index, { code1: menu.code, fristName: menu.name });
      }
    },
    // 新增/编辑配置成功回调
    $_callback() {
      this.$_close();
      this.$_getOrderCompanys();
    },
    // 关闭弹窗
    $_close() {
      this.modal.show = false;
      this.modal.template = "";
      this.modal.type = "add";
      this.modal.data = {};
      this.modal.title = "";
    },
    $_showButtonManager(row) {
      let paths = this.fristNamelist.map(item => {
        return {
          code: item.code1,
          name: item.fristName
        };
      });
      paths.unshift({
        code: "root",
        name: "一级菜单列表"
      });
      paths.push({
        code: row.code,
        name: row.name
      });
      this.modal.template = "button-manager";
      this.modal.title = "按钮管理";
      this.modal.data = {
        menu: { ...row },
        paths
      };
      this.modal.show = true;
    }
  },
  mounted() {
    this.visible = true;
    this.$_getOrderCompanys();
  },
  components: {
    AddEdit,
    ButtonManager,
    statues: {
      template: `<span>{{row.status === 1 ? '显示': '隐藏'}}</span>`,
      props: { row: { type: Object, require: true } }
    }
  }
};
</script>

<style lang="scss" scoped>
.modal-menu-management {
  /deep/ .el-dialog {
    .el-dialog__body {
      height: 642px;
    }
  }
}
.content {
  padding: 20px;
}
.table-box {
  position: relative;
  height: 496px;
  border: 1px solid #eee;
}
.table-list__empty {
  width: 412px;
  height: 310px;
  background-size: contain;
}
.currentloca {
  display: block;
  float: left;
}

.onmouses {
  cursor: pointer;
  color: #1895dd;
  text-decoration: underline;
}
.normalTxt {
  cursor: pointer;
  color: #333;
  text-decoration: none;
}
.breadcrumb {
  padding: 0 0 10px;
}
.break {
  line-height: 40px;
}
.top-btns {
  margin-bottom: 14px;
}
.onmouse {
  cursor: pointer;
}
.onmouses {
  cursor: pointer;
}
.onmouse:last-child {
  color: #000;
}
</style>
